import { iots, pipe } from '@code-expert/prelude';

const isValidRegExpString = (u: unknown): u is RegExp => {
  try {
    new RegExp(u as $IntentionalAny);
    return true;
  } catch {
    return false;
  }
};

const RegExpFromString = new iots.Type<RegExp, string, unknown>(
  'RegExpFromString',
  isValidRegExpString,
  (u, c) => (isValidRegExpString(u) ? iots.success(new RegExp(u)) : iots.failure(u, c)),
  String,
);

export const Config = iots.strict({
  BROWSERLIST_REGEX: RegExpFromString,
  NODE_ENV: iots.keyof({ development: null, production: null }),
  VERSION: iots.string,
});

export type Config = iots.TypeOf<typeof Config>;

export const config: Config = pipe(
  iots.parseSync(Config)({
    BROWSERLIST_REGEX: process.env.BROWSERLIST_REGEX,
    NODE_ENV: process.env.NODE_ENV,
    VERSION: process.env.VERSION,
  }),
);

export const isProduction: boolean = config.NODE_ENV === 'production';
